import { SVGProps } from 'react'

const CopyIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <g clipPath='url(#clip0_228_3215)'>
                <path
                    d='M10.25 4.5H5.25C4.69772 4.5 4.25 4.94772 4.25 5.5V10.5C4.25 11.0523 4.69772 11.5 5.25 11.5H10.25C10.8023 11.5 11.25 11.0523 11.25 10.5V5.5C11.25 4.94772 10.8023 4.5 10.25 4.5Z'
                    stroke='white'
                    strokeWidth='1.2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M2.25 8.5C1.7 8.5 1.25 8.05 1.25 7.5V2.5C1.25 1.95 1.7 1.5 2.25 1.5H7.25C7.8 1.5 8.25 1.95 8.25 2.5'
                    stroke='white'
                    strokeWidth='1.2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_228_3215'>
                    <rect width='12' height='12' fill='white' transform='translate(0.25 0.5)' />
                </clipPath>
            </defs>
        </svg>
    )
}

export default CopyIcon
